import { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import ContextTypes from "../Interfaces/context.interface";
import { SelectorState } from "../Selectors/index.selector";
import * as authActions from '../Actions/Auth.action'
import { bindActionCreators } from "redux";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { initialPermissions } from "../Constants/userPermission";
import { useLocalStorage } from "../Hooks/useLocalStorage";
//! Entra
// import { useMsal } from "@azure/msal-react";

export const useAuth = () => useContext(AuthContext);

export const AuthContext = createContext({
  info: {
    _id: '',
    email: '',
    image: '',
    firstName: '',
    lastName: '',
    utilities: {
      country: '',
      city: '',
      currency: '',
      language: ''
    },
    store: {
      name: '',
      username: '',
      image: '',
      primaryColor: ''
    },
    type: '',
    permissions: initialPermissions
  },
  linfo: {} as boolean,
  offline: false
});

export const AuthProvider = ({children} :ContextTypes["childrenProps"]) => {
  const dispatch = useDispatch();
  const navigate :NavigateFunction = useNavigate();
  const { info, linfo } = useSelector((state :SelectorState) => state.Auth);
  const { getInfo, getInfoDriver } = bindActionCreators(authActions, dispatch);
  const [offline, setOffline] = useState(false);
  const driver = localStorage.getItem("typename");

  //! Entra
  // const { instance } = useMsal();
  // Function to get Entra token
  // const getTokenEntra = async (): Promise<string | null> => {
  //   try {
  //     await instance.initialize()
  //     console.log("All Accounts:", instance.getAllAccounts()); // Debugging
  //     console.log("Active Accounts:", instance.getActiveAccount()); // Debugging
  //     let account = instance.getActiveAccount();
  //     // const account = instance.getAllAccounts()[0];
  //     if (!account) {
  //       console.error("No active account found!");
  //       const loginResponse = await instance.loginPopup(); // { scopes: ["api://YOUR_API_ID/.default"] }
  //       account = loginResponse.account;
  //       if (account) {
  //         instance.setActiveAccount(account)
  //       } else {
  //         return null;
  //       }
  //     }

  //     const tokenResponse = await instance.acquireTokenSilent({
  //       // scopes: ["User.Read"],
  //       scopes: ["openid", "profile"],
  //       account: account,
  //     });
      
  //     return tokenResponse.accessToken;
  //   } catch (error) {
  //     console.error("Error acquiring token:", error);
  //     return null;
  //   }
  // };

  useEffect(() => {
    if(!info && !linfo){
      if(driver && driver === "Driver") {
        getInfoDriver(navigate);
      } else {
        getInfo(navigate,
          //! Entra 
          // getTokenEntra
        );
      }
    }
  },[info]);

  useEffect(()=> {
    if(!navigator.onLine){
      setOffline(true);
    } else {
      setOffline(false)
    }
  },[navigator.onLine])
  
    return (
      <AuthContext.Provider value={{info, linfo, offline}}>
          {children}
      </AuthContext.Provider>
    );
  }